import React, { useEffect, useState } from 'react'
import { Row, Col, Tabs } from 'antd'
import ProCard from './ProCard'
import fetchProducts from '../helper/fetchProducts'
import SkeletonProd from './SkeletonProd'




const Ringsec = ({ title }) => {
    const [loading, setLoading] = useState(true)
    const [products, setProducts] = useState([])
    const getProducts = async () => {
        setLoading(true)
        // const temp = await fetchProducts([30402])
        const temp = await fetchProducts([
            21344,
            21347,
            21345,
            21350
        ])
        // debugger
        setProducts(temp.data.Products)
        setLoading(false)
    }
    useEffect(() => {
        getProducts()
    }, [])
    useEffect(() => {
        console.log(products)
    }, [products])
    const onChange = async (key) => {
        setLoading(true)
        setProducts([])
        const temp = await fetchProducts(JSON.parse(key))
        setProducts(temp.data.Products)
        setLoading(false)
    };
    const items = [
        {
            key: '[21344, 21347, 21345, 21350]',
            label: 'Engagement Rings',
            children: loading ? <SkeletonProd /> : (
                <Row gutter={[20, 20]}> {/* Add vertical gutter for spacing between rows */}
                    {Array.from(products).map((prod, index) => {
                        if (!prod) {
                            return null;
                        }
                        return (
                            <Col
                                key={index} // Add a unique key for each item
                                xs={24}    // Full width on extra small screens (1 column)
                                sm={12}    // Half width on small screens (2 columns)
                                md={8}     // One-third width on medium screens (3 columns)
                                lg={6}     // One-fourth width on large screens (4 columns)
                                xl={6}     // One-fourth width on extra large screens (4 columns)
                            >
                                <ProCard prod={prod} />
                            </Col>
                        );
                    })}
                </Row>
            ),
        },
        {
            key: '[22557, 5303, 15288, 5278, 30159]',
            label: 'Wedding Bands',
            children: loading ? <SkeletonProd /> : (
                <Row gutter={20}>
                    {Array.from(products).map((prod, index) => {
                        if (!prod) {
                            return null;
                        }
                        return (
                            <Col
                                key={index} // Add a unique key for each item
                                xs={24}    // Full width on extra small screens (1 column)
                                sm={12}    // Half width on small screens (2 columns)
                                md={8}     // One-third width on medium screens (3 columns)
                                lg={6}     // One-fourth width on large screens (4 columns)
                                xl={6}     // One-fourth width on extra large screens (4 columns)
                            >
                                <ProCard prod={prod} />
                            </Col>
                        );
                    })}
                </Row>

            ),
        }
    ];
    return (
        <div>
            <section className="themeRing" id="montiter">
                <div className="container">
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                            <div className="textRing">
                                <h2>{title}</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row
                        style={{ overflowX: 'hidden' }}
                        align="center"
                        justify="space"
                    >
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <div className="buttonring">
                                <Tabs style={{ width: '100%' }} className='tabs-items' defaultActiveKey="1" items={items} onChange={onChange} />
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </div>
    )
}

export default Ringsec;
